import { ChartTooltipProps } from '@mantine/charts';
import { Box, Flex, Paper, Text } from '@mantine/core';

export function OverlayedBarChartTooltip({
  label,
  payload,
}: ChartTooltipProps) {
  if (!payload) return null;

  return (
    <Paper px="md" py="sm" radius="md" shadow="md" withBorder>
      <Text fw={500} mb={5}>
        {label}
      </Text>
      {payload.map((item: any) => (
        <Flex align="center" gap="xs" key={item.name}>
          <Box
            h={12}
            style={{ backgroundColor: item.color, borderRadius: '50%' }}
            w={12}
          />
          <Text fz="sm">
            {item.name}:{' '}
            {typeof item.value === 'number'
              ? item.value.toFixed(2)
              : item.value}
          </Text>
        </Flex>
      ))}
    </Paper>
  );
}
